// extracted by mini-css-extract-plugin
module.exports = {"pt-page-menu-filter":"pt-page-menu-filter-02a8564d24f45ea5003cbda8fa9e710e"};